//src/services/abstract/PollFetcherService.ts
import type { FetchOptions, QueryParams } from '@/types/api.types';

/**
 * Abstract base class for data fetching services.
 * Implementations should delegate to your http client layer.
 */
export abstract class PollFetcherService {
  abstract post<T = unknown>(
    path: string,
    body?: unknown,
    options?: FetchOptions & { onUploadProgress?: (event: ProgressEvent) => void }
  ): Promise<T>;

  abstract get<T = unknown>(
    path: string,
    params?: QueryParams,
    options?: FetchOptions
  ): Promise<T>;

  abstract patch<T = unknown>(
    path: string,
    body?: unknown,
    options?: FetchOptions
  ): Promise<T>;

  abstract put<T = unknown>(
    path: string,
    body?: unknown,
    options?: FetchOptions
  ): Promise<T>;

  abstract del<T = unknown>(
    path: string,
    options?: FetchOptions
  ): Promise<T>;
}
